@if (profile().emailVerified) {
  <button
    class="button icon upload-button {{ buttonType }} {{ size }}"
    [class.proccessing]="processing"
    (click)="openFilePicker()"
    [disabled]="disabled"
  >
    <ly-icon icon="upload"></ly-icon>
    Upload media
  </button>

  <input
    #fileInput
    type="file"
    multiple
    accept="image/*,video/*"
    (change)="onFileSelected($event)"
    style="display: none"
  />
} @else {
  <button
    lyConfirm
    lyConfirm
    [lyConfirmTitle]="'Verify Email'"
    [lyConfirmContent]="
      'Almost there! Check your inbox to confirm your email first.'
    "
    [lyConfirmBtnClasses]="'button indigo'"
    [lyConfirmBtnLabel]="'Ok, got it'"
    class="button icon upload-button {{ buttonType }} {{ size }}"
  >
    <ly-icon icon="upload"></ly-icon>
    Upload media
  </button>
}
